import { React, useEffect, useState } from "react";
import { AddNoteFormContainer, FormTitle } from "./NotesPanel.styled";
import { Button, TextField, Box, MenuItem } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useEditNoteMutation, useGetRequestSatatusQuery, usePostNoteMutation } from "../../../services/ClientService";
import useFetchWithMsal from "../../../utils/useFetchWithMsal";

export const AddNoteForm = (props) => {
  const { closeForm, types, clientId, editNoteInfo, readOnly = false } = props;
  const { skip } = useFetchWithMsal();
  const [type, setType] = useState(null);
  const [status, setStatus] = useState(editNoteInfo?.requestStatus || 1);
  const [message, setMessage] = useState('');
  const [postNote] = usePostNoteMutation();
  const { data: requestStatuses } = useGetRequestSatatusQuery({ skip });
  const [editNote] = useEditNoteMutation();

  const findElementIndexById = (id) => types.findIndex(element => element.id === id);

  useEffect(() => {
    if (editNoteInfo) setMessage(editNoteInfo?.text);
  }, [editNoteInfo]);

  useEffect(() => {
    if (types) {
      setType(editNoteInfo ? findElementIndexById(editNoteInfo?.quickNoteTypeId) + 1 : 1);
    }
  }, [types?.length]);

  const onSubmit = () => {
    if (readOnly) { closeForm(); return; }
    if (editNoteInfo) {
      editNote({
        data: {
          text: message,
          clientId,
          quickNoteTypeId: type,
          ownerId: editNoteInfo.ownerId,
          quickNoteRequestSatatusId: status || null,
        },
        noteId: editNoteInfo.id,
      });
    } else {
      postNote({ text: message, clientId, quickNoteTypeId: type, quickNoteRequestSatatusId: status || null });
    }
    closeForm(message, clientId, type);
  };

  return (
    <AddNoteFormContainer editNoteInfo={editNoteInfo}>
      {!editNoteInfo && <FormTitle>Add Note</FormTitle>}
      {readOnly && <FormTitle>View Note (read-only)</FormTitle>}
      <TextField
        select
        label="Type"
        size="small"
        fullWidth
        value={type ?? ''}
        onChange={(e) => setType(e.target.value)}
        disabled={readOnly}
        sx={{ mb: 1, '& .MuiInputBase-input': { fontSize: '12px' } }}
      >
        {types?.map((t, i) => (
          <MenuItem key={t.id} value={i + 1} sx={{ fontSize: '12px' }}>{t.name}</MenuItem>
        ))}
      </TextField>
      {type === 6 && (
        <TextField
          select
          label="Status"
          size="small"
          fullWidth
          value={status ?? ''}
          onChange={(e) => setStatus(e.target.value)}
          disabled={readOnly}
          sx={{ mb: 1, '& .MuiInputBase-input': { fontSize: '12px' } }}
        >
          {requestStatuses?.map((s, i) => (
            <MenuItem key={s.id} value={i + 1} sx={{ fontSize: '12px' }}>{s.name}</MenuItem>
          ))}
        </TextField>
      )}
      <TextField
        multiline
        minRows={4}
        fullWidth
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Write a note…"
        size="small"
        InputProps={{ readOnly }}
        sx={{
          mt: 0.5,
          '& .MuiInputBase-input': { fontSize: '12px' },
          '& .MuiOutlinedInput-root': { bgcolor: 'rgba(248, 239, 231, 0.4)' },
        }}
      />
      <Box sx={{ display: 'flex', gap: 1, mt: 1.5 }}>
        {!readOnly && (
          <Button
            size="small"
            variant="contained"
            startIcon={<SaveIcon fontSize="small" />}
            onClick={onSubmit}
            sx={{ fontSize: '12px' }}
          >
            Save
          </Button>
        )}
        <Button
          size="small"
          variant="outlined"
          startIcon={<CloseIcon fontSize="small" />}
          onClick={closeForm}
          sx={{ fontSize: '12px' }}
        >
          {readOnly ? 'Close' : 'Cancel'}
        </Button>
      </Box>
    </AddNoteFormContainer>
  );
};